import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import MultiSelectFilter from "./MultiSelectFilter/MultiSelectFilter";
import { fetchContractorsList } from "../../../actions/Contractors/contractors";

const ContractorMultiSelectFilter = ({
  actions: { fetchList },
  list,
  isFetching,
  valueKey = "id",
  numbers = true,
  ...extraProps
}) => {
  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const options = useMemo(
    () =>
      list
        .sort(item => item.name)
        .map(item => ({
          key: item.id,
          text: item.name,
          value: item[valueKey]
        })),
    [list]
  );

  return (
    <MultiSelectFilter
      options={options}
      numbers={numbers}
      loading={isFetching}
      {...extraProps}
    />
  );
};

const mapStateToProps = ({
  contractors: {
    list: { content, isFetching }
  }
}) => {
  return {
    list: content,
    isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchList: fetchContractorsList
    },
    dispatch
  )
});

ContractorMultiSelectFilter.propTypes = {
  isFetching: PropTypes.bool,
  list: PropTypes.array,
  actions: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorMultiSelectFilter);
